Ext.define('Admin.view.layout.Grid',{
    extend: 'Admin.view.template.Grid',
    xtype: 'adminlayout',
    title: 'Layout Management',
    url: 'layouts_path',
    columns: [
        {
            dataIndex: 'name',
            text: 'Name',
            width: 300
        }
    ],
    disableConfig:{
        disableIsActiveColumn: true
    },
    customActionColumns: [
        {
            position: 0,
            iconCls: 'x-fa fa-clone x-btn-col-icon-info',
            tooltip: 'Copy Layout',
            handler: function(grid, rowIndex, colIndex, item, e, record, row){
                Ext.Msg.confirm('Copy Layout',`Are you sure want to copy "${record.get('name')}" ?`, function(ans){
                    if(ans == "yes"){
                        grid.mask('Copying...');
                        Ext.Ajax.request({
                            method: 'get',
                            url: Routes.duplicate_layout_path(record.get('id')),
                            callback: function(opts, success, status){
                                const responseJSON = Ext.JSON.decode(status.responseText);
                                notify(responseJSON.message);
                                grid.getStore().reload();
                                grid.unmask()
                            }
                        })
                    }
                })
            }
        }
    ]
})